import { useTranslation } from "react-i18next"
import { Box, Stack, Tooltip } from "@mui/material"

import WeatherServiceIcon from "icons/WeatherServiceIcon"

const WeatherServiceTooltipIcon = () => {
  const { t } = useTranslation()
  return (
    <Tooltip
      title={
        <Stack gap={2}>
          <div key={"weather-service"}>
            {t("plots_descriptions.WEATHER_SERVICE_DATA")}
          </div>
        </Stack>
      }
      enterTouchDelay={0}
      placement="bottom-start"
      arrow
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "help",
        }}
      >
        <WeatherServiceIcon />
      </Box>
    </Tooltip>
  )
}

export default WeatherServiceTooltipIcon
